<template>
  <div>
    <HeroSection />
    <AboutSection />
    <ServicesSection />
    <section class="py-12 px-6">
      <div class="container mx-auto max-w-6xl card-neumorphic !p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <h2 class="text-2xl font-poppins font-semibold text-dark-gray mb-2">
            Service-first + all 14 districts
          </h2>
          <p class="text-dark-gray/70">
            Buyers search by service — camps, outsourcing, lab partnership — then by city. We cover both.
          </p>
        </div>
        <div class="flex flex-col sm:flex-row gap-3 shrink-0">
          <RouterLink
            to="/services/phlebotomy-services-kerala"
            class="btn-neumorphic !py-3 text-light-purple whitespace-nowrap text-center"
          >
            Phlebotomy services Kerala
          </RouterLink>
          <RouterLink
            to="/insights"
            class="btn-neumorphic !py-3 text-dark-gray whitespace-nowrap text-sm text-center"
          >
            B2B insights
          </RouterLink>
        </div>
      </div>
    </section>
    <ClientsSection />
    <ContactSection />
  </div>
</template>

<script>
import { computed } from 'vue'
import HeroSection from '../components/HeroSection.vue'
import AboutSection from '../components/AboutSection.vue'
import ServicesSection from '../components/ServicesSection.vue'
import ClientsSection from '../components/ClientsSection.vue'
import ContactSection from '../components/ContactSection.vue'
import {
  graphSchema,
  localBusinessSchema,
  medicalBusinessSchema,
  organizationSchema,
  useSeo,
  websiteSchema,
} from '../composables/useSeo'

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    AboutSection,
    ServicesSection,
    ClientsSection,
    ContactSection,
  },
  setup() {
    useSeo(
      computed(() => ({
        title: 'Corporate Health Camps & Phlebotomy Kerala | Homvisit',
        description:
          'Homvisit runs corporate health camps and onsite phlebotomy across Kerala. Hire camp teams, partner with labs, or join our phlebotomist network.',
        path: '/',
        keywords: [
          'corporate health camp Kerala',
          'corporate medical camp Kerala',
          'onsite phlebotomy Kerala',
          'phlebotomist vacancy in kerala',
          'medical camp organizers Kerala',
        ],
        schema: graphSchema([
          organizationSchema(),
          localBusinessSchema(),
          medicalBusinessSchema(),
          websiteSchema(),
        ]),
      }))
    )
  },
}
</script>
